/* eslint-disable indent */
// Above disable is done because of some linting conflicts between eslint and prettier.
import * as actionTypes from "./actions";

const initialState = {
  authInfo: {
    isLoggedIn: false,
    role: "",
    config: {},
    env: ""
  }
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_AUTH_INFO: {
      return {
        ...state,
        authInfo: {
          ...action.authInfo
        }
      };
    }
    default:
      return state;
  }
};
